module.exports = __webpack_public_path__ + "static/media/404-errorImage.fa482df5.png";